import { resetPasswordApi } from "@/api/services/main/auth";
import { Button } from "@/components/elements/Button";
import { Form } from "@/components/elements/Form";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { resetPasswordSchema } from "@/features/auth/schema/resetPasswordSchema";
import { TResetPasswordForm } from "@/features/auth/types/resetPasswordForm";
import { TResetPasswordQuery } from "@/features/auth/types/resetPasswordQuery";
import { AppRoutes } from "@/routes/config";
import { text } from "@/theme/colors";
import { setErrorForm, showError } from "@/utils/error";
import { getQueryFromURL } from "@/utils/url";
import { yupResolver } from "@hookform/resolvers/yup";
import { Paper, Stack, Typography, styled } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const initForm: TResetPasswordForm = {
  externalId: "",
  newPassword: "",
  confirmNewPassword: "",
};

export const ResetPasswordForm = () => {
  const query = getQueryFromURL<TResetPasswordQuery>();
  const navigate = useNavigate();
  const methods = useForm<TResetPasswordForm>({
    mode: "onChange",
    defaultValues: { ...initForm, externalId: query?.externalId },
    resolver: yupResolver(resetPasswordSchema),
  });
  const { control } = methods;

  const onSubmit = async (data: TResetPasswordForm) => {
    const { newPassword } = data;
    if (!query) return;
    const { email, resetToken, externalId } = query;
    try {
      if (email && resetToken) {
        await resetPasswordApi({ email, newPassword, resetToken, externalId });
        navigate(AppRoutes.resetPasswordComplete, { state: { resetCompleted: true, externalId, email } });
      }
    } catch (error) {
      showError(error);
      setErrorForm(methods, error);
    }
  };

  return (
    <Container>
      <Form methods={methods} onSubmit={onSubmit} enableBlocker={false} schema={resetPasswordSchema}>
        <Stack gap={3} width={400}>
          <Typography variant="head20Bold" color={text.primary} textAlign="center">
            パスワード再発行
          </Typography>
          <Typography variant="body14" color={text.secondary}>
            新しいパスワードを入力してください。
          </Typography>

          <FormField control={control} name="externalId">
            <Input type="text" size="lg" readonly />
          </FormField>
          <FormField label="メールアドレス">
            <Input type="text" size="lg" readonly nonControl value={query?.email ?? ""} />
          </FormField>
          <FormField control={control} name="newPassword">
            <Input type="password" size="lg" />
          </FormField>
          <FormField control={control} name="confirmNewPassword">
            <Input type="password" size="lg" />
          </FormField>

          <Typography variant="cap12" color={text.secondary}>
            ※パスワードはアルファベット大文字・小文字・数字・記号を含む12文字以上で入力してください。
          </Typography>

          <Button type="submit" size="sm" variant="primary" fullWidth>
            パスワードを再発行
          </Button>
        </Stack>
      </Form>
    </Container>
  );
};

const Container = styled(Paper)`
  border-radius: 12px;
  padding: 32px;
  box-shadow:
    0 4px 4px -1px rgba(12, 12, 13, 0.05),
    0 4px 4px -1px rgba(12, 12, 13, 0.1) !important;
`;
